import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "h20" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_4 = {
  class: "title mc",
  style: {"width":"200px"}
}
const _hoisted_5 = {
  key: 0,
  class: "header_title fs24 centered",
  style: {"color":"#696969"}
}
const _hoisted_6 = {
  key: 1,
  class: "header_title fs24 centered",
  style: {"color":"#696969"}
}
const _hoisted_7 = {
  class: "text",
  style: {"color":"#696969"}
}
const _hoisted_8 = {
  key: 0,
  class: "fs13 centered"
}
const _hoisted_9 = {
  key: 1,
  class: "mt15"
}
const _hoisted_10 = { key: 2 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "fs12 fw600" }, "オンライン会議URLや開催場所", -1)
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "fs12 fw600 mt10" }, "連絡事項等", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_15 = {
  class: "w100 posAb",
  style: {"bottom":"0"}
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_17 = {
  class: "posAb w100 centered",
  style: {"right":"0","bottom":"0"}
}
const _hoisted_18 = {
  class: "fs14 whiteColor fw600",
  style: {"padding-top":"15px"}
}
const _hoisted_19 = {
  key: 0,
  style: {"display":"inline-block"}
}
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 1,
  class: "w100 lgreyBg fs16 pointer centered",
  style: {"line-height":"50px","height":"50px"}
}
const _hoisted_22 = {
  style: {"width":"130px","padding-top":"18px"},
  class: "mc"
}
const _hoisted_23 = { class: "fl" }
const _hoisted_24 = {
  key: 2,
  class: "with_white_bg dgrey fs16 pointer centered w100 lgreyBg disabled",
  style: {"line-height":"50px","height":"50px"}
}
const _hoisted_25 = {
  key: 0,
  class: "fs14 fw400"
}
const _hoisted_26 = {
  key: 1,
  class: "fs14 fw400"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_progress_bar = _resolveComponent("md-progress-bar")!
  const _component_PossibleDateControl = _resolveComponent("PossibleDateControl")!
  const _component_SelectTag = _resolveComponent("SelectTag")!
  const _component_TextfieldTag = _resolveComponent("TextfieldTag")!
  const _component_TextareaTag = _resolveComponent("TextareaTag")!
  const _component_UserIcon = _resolveComponent("UserIcon")!
  const _component_MdProgressSpinner = _resolveComponent("MdProgressSpinner")!
  const _component_AdLimitFree = _resolveComponent("AdLimitFree")!
  const _component_VueFinalModal = _resolveComponent("VueFinalModal")!

  return (_openBlock(), _createBlock(_component_VueFinalModal, {
    "modal-id": "FixScheduleSmallModal",
    "content-class": `rad10 with_white_bg shadowContent ${
            _ctx.isPargFixer() ? `pargFixer` : `modalSmall`
        }  noscroll FixScheduleModal`,
    onBeforeOpen: _ctx.openModal
  }, {
    default: _withCtx(() => [
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_md_progress_bar, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: "pad15",
        style: _normalizeStyle({
                height: _ctx.isSP ? `260px` : _ctx.isPargFixer() ? `440px` : `320px`,
                width: `400px`,
            })
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("img", {
            src: _ctx.$getAssetImageUrl(`/assets/popUp/close_dark_grey.png`),
            width: "30",
            height: "30",
            class: "fr pointer",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.hideFixScheduleModal && _ctx.hideFixScheduleModal(...args)))
          }, null, 8, _hoisted_2)
        ]),
        _hoisted_3,
        _createElementVNode("div", {
          class: "ofs",
          style: _normalizeStyle({
                    height: `${_ctx.contentHeight}px`,
                    overscrollBehavior: `contain`,
                })
        }, [
          _createElementVNode("div", _hoisted_4, [
            (_ctx.from == `vote`)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, "全体を確定"))
              : (_openBlock(), _createElementBlock("p", _hoisted_6, "確認"))
          ]),
          _createElementVNode("div", _hoisted_7, [
            (_ctx.from == `vote`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, "一度確定すると取り消せません。"))
              : _createCommentVNode("", true),
            _createVNode(_component_PossibleDateControl, { controlPressKey: _ctx.useKeyBind }, null, 8, ["controlPressKey"]),
            (_ctx.from == `vote`)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createVNode(_component_SelectTag, {
                    name: "fix_vote_type",
                    id: "fix_vote_type",
                    class: "fl fs14 roundForm",
                    style: {"min-width":"300px","height":"50px"},
                    options: _ctx.SelectUtil.votedRoomFixTypes.map(e => e.name),
                    defaultOption: _ctx.SelectUtil.votedRoomFixTypes[0].name,
                    onSelectValue: _ctx.selectVoteFixType,
                    isDisabled: false
                  }, null, 8, ["options", "defaultOption", "onSelectValue"])
                ]))
              : _createCommentVNode("", true),
            (_ctx.isPargFixer())
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_TextfieldTag, {
                    name: "online_url",
                    id: "online_url",
                    class: "fl fs14 roundForm",
                    style: {"min-width":"100%","height":"50px"},
                    value: _ctx.onlineUrl,
                    onInputValue: _ctx.inputOnlineUrl
                  }, null, 8, ["value", "onInputValue"]),
                  _hoisted_12,
                  _hoisted_13,
                  _createVNode(_component_TextareaTag, {
                    name: "memo",
                    id: "memo",
                    class: "fl fs14 roundForm",
                    style: {"min-width":"100%","height":"120px","border":"1px solid #eee"},
                    value: _ctx.memo,
                    onInputValue: _ctx.inputMemo
                  }, null, 8, ["value", "onInputValue"]),
                  _hoisted_14
                ]))
              : _createCommentVNode("", true)
          ])
        ], 4)
      ], 4),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          (_ctx.canFix && !_ctx.isPreview && !_ctx.loading)
            ? (_openBlock(), _createElementBlock("section", {
                key: 0,
                id: "roomCloseButton",
                class: "w100 pinkBg fs16 pointer centered",
                style: {"line-height":"50px","height":"50px"},
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.fixSchedule && _ctx.fixSchedule(...args)))
              }, [
                _createElementVNode("div", _hoisted_18, [
                  _createTextVNode(" この日程で確定 "),
                  (_ctx.selectedMag)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createTextVNode(" （選択中: "),
                        (_ctx.selectedMag.profile_image_urls && _ctx.selectedMag.profile_image_urls[0])
                          ? (_openBlock(), _createBlock(_component_UserIcon, {
                              key: 0,
                              width: 24,
                              canEdit: false,
                              imageUrl: _ctx.selectedMag.profile_image_urls[0],
                              style: `display:inline-block;margin-top:-3px;`,
                              showTooltip: true
                            }, null, 8, ["imageUrl"]))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: _ctx.$getAssetImageUrl(`/assets/icons/usertype_grey.png`),
                              width: "30",
                              height: "30",
                              style: {"margin-top":"-5px"}
                            }, null, 8, _hoisted_20)),
                        _createTextVNode(" ） ")
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : (_ctx.loading)
              ? (_openBlock(), _createElementBlock("section", _hoisted_21, [
                  _createElementVNode("div", _hoisted_22, [
                    _createVNode(_component_MdProgressSpinner, {
                      width: `30`,
                      class: "fl",
                      style: {"margin-top":"-8px"}
                    }),
                    _createElementVNode("p", _hoisted_23, "  " + _toDisplayString(_ctx.$t(`title.sending`)), 1)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("section", _hoisted_24, [
                  (_ctx.isPreview)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_25, "プレビューのため確定できません"))
                    : (_openBlock(), _createElementBlock("span", _hoisted_26, "現在確定できません"))
                ]))
        ])
      ]),
      _createVNode(_component_AdLimitFree, {
        showAds: _ctx.showAds,
        addFrom: `日程確定モーダル`,
        onFadeOutAdModal: _ctx.fadeOutAdModal
      }, null, 8, ["showAds", "onFadeOutAdModal"])
    ]),
    _: 1
  }, 8, ["content-class", "onBeforeOpen"]))
}